const WORKFLOW_EXEC_FAILED = { message: "Workflow execution failed", severity: "error", status: 500, service: "workflow" };
const WORKFLOW_TIMEOUT = { message: "Workflow execution timed out", severity: "error", status: 504, service: "workflow" };
// A caller asking for one label past the cap. `info`, not `error`: the request was refused
// and nothing is wrong with the service, so it must not feed the 5xx-rate page.
const WORKFLOW_LABEL_LIMIT = { message: "Too many labels for one workflow", severity: "info", status: 400, service: "workflow" };
// The org may read workflow code but not save it. `info`, not `error`: the
// request was refused by configuration and nothing is wrong with the service,
// so it must not feed the 5xx-rate page. 403 rather than 401 — the caller is
// authenticated and the answer will not change by re-authenticating.
const WORKFLOW_CODE_READ_ONLY = { message: "This organisation can read workflow code but not change it", severity: "info", status: 403, service: "workflow" };
// A synchronous test run (POST /workflows/test, /workflows/:id/test) that failed
// because of the workflow itself. `info`: the service did its job, so none of
// these may feed the 5xx-rate page (KAT-8736, where they answered 500).
const WORKFLOW_CODE_ERROR = { message: "Workflow code failed", severity: "info", status: 422, service: "workflow" };
const WORKFLOW_TEST_TIMEOUT = { message: "Workflow test run timed out", severity: "info", status: 408, service: "workflow" };
const WORKFLOW_MEMORY_LIMIT = { message: "Workflow exceeded the sandbox memory limit", severity: "info", status: 422, service: "workflow" };
const WORKFLOW_RESULT_TOO_LARGE = { message: "Workflow returned a result over the size limit", severity: "info", status: 413, service: "workflow" };
/** Workflow service codes. Canonical `WF-*`; legacy flat names kept as aliases. */
export const WORKFLOW_ERRORS = {
    "WF-EXEC-FAILED": WORKFLOW_EXEC_FAILED,
    "WF-TIMEOUT": WORKFLOW_TIMEOUT,
    "WF-LABEL-LIMIT": WORKFLOW_LABEL_LIMIT,
    "WF-CODE-READONLY": WORKFLOW_CODE_READ_ONLY,
    "WF-CODE-ERROR": WORKFLOW_CODE_ERROR,
    "WF-TEST-TIMEOUT": WORKFLOW_TEST_TIMEOUT,
    "WF-MEMORY-LIMIT": WORKFLOW_MEMORY_LIMIT,
    "WF-RESULT-TOO-LARGE": WORKFLOW_RESULT_TOO_LARGE,
    WORKFLOW_EXEC_FAILED,
    WORKFLOW_TIMEOUT,
    WORKFLOW_LABEL_LIMIT,
    WORKFLOW_CODE_READ_ONLY,
};
//# sourceMappingURL=workflow.js.map